import React, { useEffect, useState } from "react";
import { 
  FaUserGraduate, 
  FaBook, 
  FaMoneyBillWave, 
  FaChalkboardTeacher,
  FaPhone,
  FaMobileAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaCalendarAlt,
  FaUniversity,
  FaIdCard,
  FaCity,
  FaEdit,
  FaTimes,
} from "react-icons/fa";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import SummaryApi from '../common/index';
import { toast } from 'react-toastify';
import { FaLock, FaUnlock ,fasplash} from 'react-icons/fa';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { LiaUniversitySolid } from "react-icons/lia";
import { CiUser } from "react-icons/ci";
const AdminStudentDashboard = () => {
  const [counts, setCounts] = useState({
    enrolledCourses: 0,
    completedCourses: 0,
    pendingPayments: 0,
    attendance: 0
  });

  const [profile, setProfile] = useState({
    student_code:"",
    college_id: '',
    stu_clg_enrollment_number: '',
    first_name: '',
    last_name: '',
    ug_pg: '',
    academic_course: '',
    academic_year: '',
    email: '',
    mobile_number: '',
    alternate_mobile_number: '',
    address: '',
    city: '',
    is_active: '0',
    is_self_registered: 0,
    created_date: '',
    password: '',
    college_code: '',
    college_name: '',
    contact_number: '',
    contact_person: '',
    student_image: ''
  });

  const [enrolledCourses, setEnrolledCourses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const coursesPerPage = 5;
  const [showPassword, setShowPassword] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Theme handling based on localStorage
  useEffect(() => {
    const savedTheme = sessionStorage.getItem("admin-theme");
    const shouldBeDark = savedTheme === "dark";
    setIsDarkMode(shouldBeDark);
    
    // Apply theme to document for global CSS support
    if (shouldBeDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, []);

  // Listen for theme changes from other components
  useEffect(() => {
    const handleThemeChange = () => {
      const savedTheme = sessionStorage.getItem("admin-theme");
      const shouldBeDark = savedTheme === "dark";
      setIsDarkMode(shouldBeDark);
      
      // Apply theme to document
      if (shouldBeDark) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    };

    window.addEventListener("themeChanged", handleThemeChange);
    
    // Listen for storage changes (other tabs)
    const handleStorageChange = (e) => {
      if (e.key === "admin-theme") {
        handleThemeChange();
      }
    };
    
    window.addEventListener("storage", handleStorageChange);

    // Listen for custom theme toggle events
    const handleCustomThemeChange = () => {
      handleThemeChange();
    };
    
    window.addEventListener("adminThemeToggled", handleCustomThemeChange);
    
    return () => {
      window.removeEventListener("themeChanged", handleThemeChange);
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("adminThemeToggled", handleCustomThemeChange);
    };
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const maskPassword = (password) => {
    if (!password) return 'N/A';
    return '•'.repeat(8);
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encodedId = queryParams.get('id');
  const studentId = encodedId ? atob(encodedId) : null;

  const formatImageUrl = (imagePath) => {
    if (!imagePath || imagePath === 'N/A') return '';
    if (imagePath.startsWith('http')) return imagePath;
    if (imagePath instanceof File) return URL.createObjectURL(imagePath);
    const baseUrl = SummaryApi.Images.url.replace('/api', '');
    if (imagePath.includes(baseUrl)) return imagePath;
    if (imagePath.startsWith('uploads/')) return `${baseUrl}/${imagePath}`;
    return `${baseUrl}/${imagePath}`;
  };

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const response = await axios({
          method: SummaryApi.fetchingstudentbyid.method,
          url: SummaryApi.fetchingstudentbyid.url,
          data: { student_id: studentId }
        });

        if (response.data.status && response.data.data) {
          const studentData = response.data.data;

          const coursesResponse = await axios({
            method: SummaryApi.student_purchased_courses.method,
            url: SummaryApi.student_purchased_courses.url,
            data: { student_id: studentId }
          });

          let enrolledCoursesData = [];
          if (coursesResponse.data.status && coursesResponse.data.data) {
            enrolledCoursesData = coursesResponse.data.data.map(course => ({
              enrollment_id: course.enrollment_id,
              course_name: course.course_title || 'N/A',
              instructor_name: course.instructor_name || 'N/A',
              status: course.enrollment_status || 'N/A',
              enrollment_date: course.enrollment_date ? new Date(course.enrollment_date).toLocaleDateString() : 'N/A',
              course_price: course.course_price || '0.00',
              is_course_completed: course.is_course_completed || 0
            }));
          } 
          const completedCoursesCount = enrolledCoursesData.filter(course => course.is_course_completed === 1).length;
          const pendingPaymentsTotal = enrolledCoursesData.reduce((total, course) => {
            return total + parseFloat(course.course_price || 0);
          }, 0);

          setCounts({
            enrolledCourses: enrolledCoursesData.length,
            completedCourses: completedCoursesCount,
            pendingPayments: pendingPaymentsTotal,
            attendance: 0
          });

          const formattedImage = formatImageUrl(studentData.student_image);

          setProfile({
            college_id: studentData.college_id || '',
                  student_code: studentData.student_code || '',
            stu_clg_enrollment_number: studentData.stu_clg_enrollment_number || '',
            first_name: studentData.first_name || '',
            last_name: studentData.last_name || '',
            ug_pg: studentData.ug_pg || '',
            academic_course: studentData.academic_course || '',
            academic_year: studentData.academic_year || '',
            email: studentData.email || '',
            mobile_number: studentData.mobile_number || '',
            alternate_mobile_number: studentData.alternate_mobile_number || '',
            address: studentData.address || '',
            city: studentData.city || '',
            is_self_registered: studentData.is_self_registered || 0,
            is_active: studentData.is_active?.toString() || '0',
            created_date: studentData.created_date || '',
            password: studentData.password || '',
            college_code: studentData.college_code || '',
    college_name: studentData.college_name || studentData.clg_name || 'N/A',
            contact_number: studentData.contact_number || '',
            contact_person: studentData.contact_person || '',
            student_image: formattedImage
          });

          setImagePreview(formattedImage);
          setEnrolledCourses(enrolledCoursesData);
        }
      } catch (error) {
        console.error('Error fetching student data:', error);
        toast.error('Failed to load student data');
        setCounts({ enrolledCourses: 0, completedCourses: 0, pendingPayments: 0, attendance: 0 });
        setProfile({
          college_id: '',
                  student_code: '', 
          stu_clg_enrollment_number: '',
          first_name: '',
          last_name: '',
          ug_pg: '',
          academic_course: '',
          academic_year: '',
          email: '',
          mobile_number: '',
          alternate_mobile_number: '',
          address: '',
          city: '',
          is_self_registered: 0,
          is_active: '0',
          created_date: '',
          password: '',
          college_code: '',
          college_name: '',
          contact_number: '',
          contact_person: '',
          student_image: ''
        });
        setImagePreview('');
        setEnrolledCourses([]);
      }
    };

    if (studentId) fetchStudentData();
  }, [studentId]);

// const handleUpdate = async (e) => {
//   e.preventDefault();
//   setIsSubmitting(true);

//   try {
//     const formData = new FormData();
    
//     formData.append('college_id', profile.college_id);
//     formData.append('stu_clg_enrollment_number', profile.stu_clg_enrollment_number);
//     formData.append('first_name', profile.first_name);
//     formData.append('last_name', profile.last_name);
//     formData.append('ug_pg', profile.ug_pg);
//     formData.append('academic_course', profile.academic_course);
//     formData.append('academic_year', profile.academic_year);
//     formData.append('email', profile.email);
//     formData.append('mobile_number', profile.mobile_number);
//     formData.append('alternate_mobile_number', profile.alternate_mobile_number);
//     formData.append('address', profile.address);
//     formData.append('city', profile.city);
//     formData.append('is_self_registered', profile.is_self_registered.toString());
//     formData.append('is_active', profile.is_active);
//     formData.append('password', profile.password);

//     // ---- Conditionally pass college data ----
//     if (profile.is_self_registered === 1 && profile.college_id === 0) {
//       // Self-registered student: pass clg_name with actual value and college_id as 0
//       formData.append('clg_name', profile.college_name);
//       formData.append('college_id', '0');
//       formData.append('college_name', 'N/A'); // Set college_name to N/A for self-registered
//     } else if (profile.is_self_registered === 0 && profile.college_id > 0) {
//       // College student: pass college_name with actual value and clg_name as N/A
//       formData.append('college_id', profile.college_id);
//       formData.append('college_name', profile.college_name);
//       formData.append('clg_name', 'N/A'); // Set clg_name to N/A for college students
//     } else {
//       // Fallback
//       formData.append('college_id', profile.college_id);
//       formData.append('college_name', profile.college_name);
//       formData.append('clg_name', 'N/A');
//     }

//     if (profile.student_image instanceof File) {
//       formData.append('student_image', profile.student_image);
//     }

//     formData.append('student_id', studentId);

//     const response = await fetch(SummaryApi.studentupdate.url, {
//       method: SummaryApi.studentupdate.method,
//       body: formData,
//     });

//     const data = await response.json();

//     if (data.status) {
//       toast.success('Student updated successfully!');
//       setShowUpdateModal(false);

//       const fetchResponse = await axios({
//         method: SummaryApi.fetchingstudentbyid.method,
//         url: SummaryApi.fetchingstudentbyid.url,
//         data: { student_id: studentId }
//       });

//       if (fetchResponse.data.status && fetchResponse.data.data) {
//         const studentData = fetchResponse.data.data;
//         const formattedImage = formatImageUrl(studentData.student_image);

//         setProfile({
//           college_id: studentData.college_id || '',
//           stu_clg_enrollment_number: studentData.stu_clg_enrollment_number || '',
//           first_name: studentData.first_name || '',
//           last_name: studentData.last_name || '',
//           ug_pg: studentData.ug_pg || '',
//           academic_course: studentData.academic_course || '',
//           academic_year: studentData.academic_year || '',
//           email: studentData.email || '',
//           mobile_number: studentData.mobile_number || '',
//           alternate_mobile_number: studentData.alternate_mobile_number || '',
//           address: studentData.address || '',
//           city: studentData.city || '',
//           is_self_registered: studentData.is_self_registered || 0,
//           is_active: studentData.is_active?.toString() || '0',
//           created_date: studentData.created_date || '',
//           password: studentData.password || '',
//           college_code: studentData.college_code || '',
//           contact_number: studentData.contact_number || '',
//           contact_person: studentData.contact_person || '',
//           // Use the correct field based on college_id
//           college_name: studentData.college_id > 0 ? (studentData.college_name ?? "") : (studentData.clg_name ?? ""),
//           student_image: formattedImage
//         });
//         setImagePreview(formattedImage);
//       }
//     } else {
//       toast.error(data.message || 'Failed to update student');
//     }
//   } catch (error) {
//     console.error('Error updating student:', error);
//     toast.error('Error updating student');
//   } finally {
//     setIsSubmitting(false);
//   }
// };
const handleUpdate = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    const formData = new FormData();

    // === Always send these ===
    formData.append('student_id', studentId);
    formData.append('stu_clg_enrollment_number', profile.stu_clg_enrollment_number);
    formData.append('first_name', profile.first_name);
    formData.append('last_name', profile.last_name);
    formData.append('ug_pg', profile.ug_pg);
    formData.append('academic_course', profile.academic_course);
    formData.append('academic_year', profile.academic_year);
    formData.append('email', profile.email);
    formData.append('mobile_number', profile.mobile_number);
    formData.append('alternate_mobile_number', profile.alternate_mobile_number);
    formData.append('address', profile.address);
    formData.append('city', profile.city);
    formData.append('password', profile.password);
    formData.append('is_active', profile.is_active);
    formData.append('is_self_registered', profile.is_self_registered.toString());

    // === Profile Image ===
    if (profile.student_image instanceof File) {
      formData.append('student_image', profile.student_image);
    }

    // === COLLEGE LOGIC - THIS IS THE GOLDEN PART ===
    const isEditableCollege = profile.college_id == 0; 
    // True for both: Self-registered OR Admin-created

    if (isEditableCollege) {
      // Self or Admin-created → use custom college name
      formData.append('college_id', '0');
      formData.append('clg_name', profile.college_name || '');     // ← Custom name goes here
      formData.append('college_name', 'N/A');                      // Official = N/A
    } else {
      // Official college student
      formData.append('college_id', profile.college_id);
      formData.append('college_name', profile.college_name || '');
      formData.append('clg_name', 'N/A');                          // Custom = N/A
    }

    // Optional: still send these (read-only fields)
    formData.append('college_code', profile.college_code || '');
    formData.append('contact_number', profile.contact_number || '');
    formData.append('contact_person', profile.contact_person || '');

    // === Submit ===
    const response = await fetch(SummaryApi.studentupdate.url, {
      method: SummaryApi.studentupdate.method,
      body: formData,
    });

    const data = await response.json();

    if (data.status) {
      toast.success('Student updated successfully!');

      // Refetch fresh data
      const fetchResponse = await axios({
        method: SummaryApi.fetchingstudentbyid.method,
        url: SummaryApi.fetchingstudentbyid.url,
        data: { student_id: studentId }
      });

      if (fetchResponse.data.status && fetchResponse.data.data) {
        const studentData = fetchResponse.data.data;
        const formattedImage = formatImageUrl(studentData.student_image);

        setProfile(prev => ({
          ...prev,
          college_id: studentData.college_id || '',
             student_code: studentData.student_code || '',
college_name: studentData.college_id > 0 ? (studentData.college_name ?? "") : (studentData.clg_name ?? ""),
          college_code: studentData.college_code || '',
          contact_number: studentData.contact_number || '',
          contact_person: studentData.contact_person || '',
          student_image: formattedImage
        }));

        setImagePreview(formattedImage);
      }

      setShowUpdateModal(false);
    } else {
      toast.error(data.message || 'Update failed');
    }
  } catch (error) {
    console.error('Update error:', error);
    toast.error('Failed to update student');
  } finally {
    setIsSubmitting(false);
  }
};
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    if (type === 'file' && files && files[0]) {
      const file = files[0];
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
      setProfile(prev => ({
        ...prev,
        student_image: file
      }));
    } else if (type === 'checkbox') {
      setProfile(prev => ({
        ...prev,
        [name]: checked ? '1' : '0'
      }));
    } else {
      setProfile(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

const handleModalClose = (e) => {
  // Only close if clicking on the backdrop itself (not its children)
  if (e.target.id === 'modal-backdrop' || e.target.classList.contains('modal-close-btn')) {
    setShowUpdateModal(false);
  }
};



const formatCreatedDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };





  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = enrolledCourses.slice(indexOfFirstCourse, indexOfLastCourse);
  const totalPages = Math.ceil(enrolledCourses.length / coursesPerPage);

  return (
    <div className={`p-4 md:p-6 lg:p-8 min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900' : 'bg-gray-50'
    }`}>
      {/* Theme Toggle Button */}

      <h2 className={`text-3xl font-bold text-center mb-8 transition-colors duration-300 ${
        isDarkMode ? 'text-white' : 'text-[#001529]'
      }`}>
        Student Dashboard
      </h2>

      {/* Widgets Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className={`rounded-xl shadow-lg p-6 flex items-center transition-colors duration-300 ${
          isDarkMode 
            ? 'bg-gradient-to-r from-blue-800 via-blue-700 to-blue-600 text-white' 
            : 'bg-gradient-to-r from-blue-600 via-blue-500 to-blue-400 text-white'
        }`}>
          <div className="p-3 rounded-xl bg-white/20 mr-4 shadow-md">
            <FaBook className="text-white text-2xl" />
          </div>
          <div>
            <h3 className="text-sm opacity-90">Enrolled Courses</h3>
            <p className="text-2xl font-bold">{counts.enrolledCourses}</p>
          </div>
        </div>

        <div className={`rounded-xl shadow-lg p-6 flex items-center transition-colors duration-300 ${
          isDarkMode 
            ? 'bg-gradient-to-r from-teal-800 via-teal-700 to-teal-600 text-white' 
            : 'bg-gradient-to-r from-teal-600 via-teal-500 to-teal-400 text-white'
        }`}>
          <div className="p-3 rounded-xl bg-white/20 mr-4 shadow-md">
            <FaUserGraduate className="text-white text-2xl" />
          </div>
          <div>
            <h3 className="text-sm opacity-90">Completed Courses</h3>
            <p className="text-2xl font-bold">{counts.completedCourses}</p>
          </div>
        </div>

        <div className={`rounded-xl shadow-lg p-6 flex items-center transition-colors duration-300 ${
          isDarkMode 
            ? 'bg-gradient-to-r from-yellow-700 via-yellow-600 to-yellow-500 text-white' 
            : 'bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-300 text-white'
        }`}>
          <div className="p-3 rounded-xl bg-white/20 mr-4 shadow-md">
            <FaMoneyBillWave className="text-white text-2xl" />
          </div>
          <div>
            <h3 className="text-sm opacity-90">Pending Payments</h3>
            <p className="text-2xl font-bold">₹{counts.pendingPayments}</p>
          </div>
        </div>

        <div className={`rounded-xl shadow-lg p-6 flex items-center transition-colors duration-300 ${
          isDarkMode 
            ? 'bg-gradient-to-r from-pink-700 via-pink-600 to-pink-500 text-white' 
            : 'bg-gradient-to-r from-pink-500 via-pink-400 to-pink-300 text-white'
        }`}>
          <div className="p-3 rounded-xl bg-white/20 mr-4 shadow-md">
            <FaChalkboardTeacher className="text-white text-2xl" />
          </div>
          <div>
            <h3 className="text-sm opacity-90">Attendance</h3>
            <p className="text-2xl font-bold">{counts.attendance}%</p>
          </div>
        </div>
      </div>

      {/* Profile + Enrolled Courses Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Profile Card */}
        <div className={`rounded-xl shadow-lg p-6 border transition-colors duration-300 ${
          isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
        }`}>
          <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
  {imagePreview ? (
    <img
      src={imagePreview}
      alt="Student"
      className="w-16 h-16 rounded-full mr-4 object-cover shadow-md"
    />
  ) : (
    <div className={`w-14 h-14 rounded-full mr-4 flex items-center justify-center font-bold text-lg shadow-md transition-colors duration-300 ${
      isDarkMode 
        ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white' 
        : 'bg-gradient-to-br from-blue-400 to-blue-500 text-white'
    }`}>
      {profile.first_name ? profile.first_name.charAt(0) : "S"}
    </div>
  )}
  <div>
    <h3 className={`text-xl font-semibold transition-colors duration-300 ${
      isDarkMode ? 'text-white' : 'text-gray-800'
    }`}>
      {profile.first_name || 'N/A'} {profile.last_name || ''}
    </h3>
    
    <div className="flex items-center gap-2 mt-2">
      {/* Status Badge */}
      <span
        className={`px-2 py-1 rounded-full text-[10px] font-semibold transition-colors duration-300 ${
          profile.is_active == "1"
            ? isDarkMode
              ? "bg-green-900 text-green-200 border border-green-600"
              : "bg-green-100 text-green-800 border border-green-400"
            : isDarkMode
              ? "bg-red-900 text-red-200 border border-red-600"
              : "bg-red-100 text-red-800 border border-red-400"
        }`}
      >
        {profile.is_active == '1' ? 'Active' : 'Inactive'}
      </span>
      
      {/* Student Type Badges with Icons */}
      {profile.is_self_registered == 1 && (
        <span className={`px-2 py-1 text-[15px] rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200`}>
          <CiUser />
        </span>
      )}
      {profile.is_self_registered == 0 && profile.college_id == 0 && (
        <span className={`px-2 py-1 text-[15px] rounded-full bg-purple-500 text-white dark:bg-purple-800 dark:text-white`}>
          Admin
        </span>
      )}
      {profile.is_self_registered == 0 && profile.college_id > 0 && (
        <span className={`px-2 py-1 text-[15px] rounded-full bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200`}>
          <LiaUniversitySolid /> 
        </span>
      )}
    </div>
  </div>
</div>
            <button 
              className={`px-4 py-1 rounded-lg shadow-md  flex items-center transition-colors duration-300 ${
                isDarkMode
? 'bg-[#1C3664] hover:bg-blue-700 text-white'
              : 'bg-[#1C3664] text-white hover:bg-blue-800'
              }`}
              onClick={() => setShowUpdateModal(true)}
            >
              <FaEdit className="mr-2" /> Edit Profile
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
                {/* <p className={`flex items-center transition-colors duration-300 ${
      isDarkMode ? 'text-gray-300' : 'text-gray-700'
    }`}>
      <FaIdCard className="mr-2 text-blue-500" /> Student Code: {profile.student_code || 'N/A'}
    </p> */}
            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaIdCard className="mr-2 text-blue-500" /> Enrollment No: {profile.student_code || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaUserGraduate className="mr-2 text-blue-500" /> UG/PG: {profile.ug_pg || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaBook className="mr-2 text-blue-500" /> Academic Course: {profile.academic_course || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaCalendarAlt className="mr-2 text-blue-500" /> Academic Year: {profile.academic_year || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaEnvelope className="mr-2 text-blue-500" /> Email: {profile.email || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaPhone className="mr-2 text-blue-500" /> Mobile: {profile.mobile_number || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaMobileAlt className="mr-2 text-blue-500" /> Alternate Mobile: {profile.alternate_mobile_number || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaMapMarkerAlt className="mr-2 text-blue-500" /> Address: {profile.address || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaCity className="mr-2 text-blue-500" /> City: {profile.city || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaUniversity className="mr-2 text-blue-500" /> College Code: {profile.college_code || 'N/A'}
            </p>

<p className={`flex items-center transition-colors duration-300 ${
  isDarkMode ? 'text-gray-300' : 'text-gray-700'
}`}>
  <FaUniversity className="mr-2 text-blue-500" /> College Name: {profile.college_name || 'N/A'}
</p>
<p className={`flex items-center transition-colors duration-300 ${
            isDarkMode ? 'text-gray-300' : 'text-gray-700'
          }`}>
            <FaCalendarAlt className="mr-2 text-blue-500" /> 
            Registered On: <span className="ml-1 font-medium">{formatCreatedDate(profile.created_date)}</span>
          </p>
            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaPhone className="mr-2 text-blue-500" /> College Contact: {profile.contact_number || 'N/A'}
            </p>

            <p className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <FaUserGraduate className="mr-2 text-blue-500" /> Contact Person: {profile.contact_person || 'N/A'}
            </p>

            <div className={`flex items-center transition-colors duration-300 ${
              isDarkMode ? 'text-gray-300' : 'text-gray-700'
            }`}>
              <button
                onClick={togglePasswordVisibility}
                className="mr-2 text-blue-500 hover:text-blue-700 dark:hover:text-blue-400 transition-colors"
                type="button"
              >
                {showPassword ? <FaUnlock /> : <FaLock />}
              </button>
              <span>
                Password:{' '}
                {showPassword
                  ? (profile.password || 'N/A')
                  : maskPassword(profile.password)}
              </span>
            </div>
          </div>
        </div>

        {/* Enrolled Courses Card */}
        <div className={`rounded-xl shadow-lg p-6 border transition-colors duration-300 ${
          isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
        }`}>
          <h3 className={`text-lg font-semibold mb-4 text-center transition-colors duration-300 ${
            isDarkMode ? 'text-blue-400' : 'text-blue-700'
          }`}>Enrolled Courses</h3>
          <div className="overflow-x-auto">
            <table className={`min-w-full border-collapse border rounded-lg text-center transition-colors duration-300 ${
              isDarkMode ? 'border-gray-600' : 'border-gray-200'
            }`}>
              <thead className={`text-white text-center transition-colors duration-300 ${
                isDarkMode 
                  ? 'bg-gradient-to-r from-blue-700 to-blue-600 border-blue-500' 
                  : 'bg-gradient-to-r from-blue-400 to-blue-300 border-blue-300'
              }`}>
                    <tr className="bg-[#1C3664] hover:bg-blue-700 dark:from-blue-800 dark:to-blue-700 text-white">
                  <th className="px-4 py-3 text-xs font-semibold uppercase border">S.No</th>
                  <th className="px-4 py-3 text-xs font-semibold uppercase border">Course Name</th>
                  <th className="px-4 py-3 text-xs font-semibold uppercase border">Instructor</th>
                  <th className="px-4 py-3 text-xs font-semibold uppercase border">Status</th>
                  <th className="px-4 py-3 text-xs font-semibold uppercase border">Enrollment Date</th>
                  <th className="px-4 py-3 text-xs font-semibold uppercase border">Price</th>
                </tr>
              </thead>
              <tbody>
                {currentCourses.length > 0 ? (
                  currentCourses.map((course, index) => {
                    const serialNumber = (currentPage - 1) * coursesPerPage + index + 1;
                    return (
                      <tr key={course.enrollment_id || index} className={`transition-colors duration-300 ${
                        isDarkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'
                      }`}>
                        <td className={`px-4 py-4 text-sm border transition-colors duration-300 ${
                          isDarkMode ? 'border-gray-600 text-gray-200' : 'border-gray-200 text-gray-800'
                        }`}>{serialNumber}</td>
                        <td className={`px-4 py-4 text-sm border transition-colors duration-300 ${
                          isDarkMode ? 'border-gray-600 text-gray-200' : 'border-gray-200 text-gray-800'
                        }`}>{course.course_name}</td>
                        <td className={`px-4 py-4 text-sm border transition-colors duration-300 ${
                          isDarkMode ? 'border-gray-600 text-gray-200' : 'border-gray-200 text-gray-800'
                        }`}>{course.instructor_name}</td>
                        <td className={`px-4 py-4 text-sm border transition-colors duration-300 ${
                          isDarkMode ? 'border-gray-600' : 'border-gray-200'
                        }`}>
                          <span className={`px-2 py-1 rounded-full text-xs font-semibold transition-colors duration-300 ${
                            course.is_course_completed === 1 
                              ? isDarkMode
                                ? 'bg-green-900 text-green-300 border border-green-600'
                                : 'bg-green-100 text-green-700 border border-green-400'
                              : course.status === 'Enrolled' || course.status === 'In Progress'
                              ? isDarkMode
                                ? 'bg-blue-900 text-blue-300 border border-blue-600'
                                : 'bg-blue-100 text-blue-700 border border-blue-400'
                              : isDarkMode
                                ? 'bg-yellow-900 text-yellow-300 border border-yellow-600'
                                : 'bg-yellow-100 text-yellow-700 border border-yellow-400'
                          }`}>
                            {course.is_course_completed === 1 ? 'Completed' : (course.status || 'Enrolled')}
                          </span>
                        </td>
                        <td className={`px-4 py-4 text-sm border transition-colors duration-300 ${
                          isDarkMode ? 'border-gray-600 text-gray-200' : 'border-gray-200 text-gray-800'
                        }`}>{course.enrollment_date}</td>
                        <td className={`px-4 py-4 text-sm border transition-colors duration-300 ${
                          isDarkMode ? 'border-gray-600 text-gray-200' : 'border-gray-200 text-gray-800'
                        }`}>₹{course.course_price}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className={`px-4 py-4 text-center text-sm border transition-colors duration-300 ${
                      isDarkMode ? 'border-gray-600 text-gray-400' : 'border-gray-200 text-gray-500'
                    }`}>
                      No courses enrolled
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {enrolledCourses.length > 0 && (
            <div className="flex justify-between items-center mt-4">
              <button
                className={`px-4 py-1 rounded transition duration-300 ${
                  isDarkMode
                    ? currentPage === 1
                      ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                      : 'bg-gradient-to-r from-blue-700 to-blue-600 text-blue-100 hover:from-blue-600 hover:to-blue-500'
                    : currentPage === 1
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                      : 'bg-gradient-to-r from-blue-300 to-blue-200 text-blue-900 hover:from-blue-400 hover:to-blue-300'
                }`}
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              <span className={`text-sm transition-colors duration-300 ${
                isDarkMode ? 'text-gray-300' : 'text-gray-700'
              }`}>
                Page {currentPage} of {totalPages}
              </span>

              <button
                className={`px-4 py-1 rounded transition duration-300 ${
                  isDarkMode
                    ? currentPage === totalPages
                      ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                      : 'bg-gradient-to-r from-blue-700 to-blue-600 text-blue-100 hover:from-blue-600 hover:to-blue-500'
                    : currentPage === totalPages
                      ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                      : 'bg-gradient-to-r from-blue-300 to-blue-200 text-blue-900 hover:from-blue-400 hover:to-blue-300'
                }`}
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Student Update Modal */}
      {showUpdateModal && (
      <div
    id="modal-backdrop"
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-auto"
    onClick={handleModalClose}
  >
         <div
      className={`rounded-lg w-full max-w-4xl md:max-w-3xl lg:max-w-4xl p-6 mx-2 sm:mx-4 md:mx-0 max-h-[90vh] overflow-y-auto transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-800' : 'bg-white'
      }`}
      onClick={(e) => e.stopPropagation()} // This prevents click inside modal from bubbling
    >
      <div className="flex justify-between items-center mb-4">
        <h3 className={`text-xl font-semibold transition-colors duration-300 ${
          isDarkMode ? 'text-white' : 'text-gray-800'
        }`}>Edit Student</h3>
        <button
          onClick={() => setShowUpdateModal(false)}
          className={`p-2 rounded-full transition-colors duration-300 ${
            isDarkMode 
              ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-700' 
              : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
          }`}
        >
          <FaTimes className="text-xl" />
        </button>
      </div>

            <form onSubmit={handleUpdate} className="grid grid-cols-1 md:grid-cols-3 gap-3 text-md">
              {/* Profile Photo Upload */}
              <div className="md:col-span-3 flex flex-col items-center mb-3">
                <label className={`w-20 h-20 rounded-full overflow-hidden border-2 mb-2 cursor-pointer transition-colors duration-300 ${
                  isDarkMode ? 'border-gray-600' : 'border-gray-300'
                }`}>
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="Profile Preview"
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className={`w-full h-full flex items-center justify-center font-bold text-lg transition-colors duration-300 ${
                      isDarkMode 
                        ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white' 
                        : 'bg-gradient-to-br from-blue-400 to-blue-500 text-white'
                    }`}>
                      {profile.first_name ? profile.first_name.charAt(0) : "S"}
                    </div>
                  )}
                  <input
                    type="file"
                    name="student_image"
                    onChange={handleChange}
                    accept="image/*"
                    className="hidden"
                  />
                </label>
                <label className={`block font-bold mb-2 text-center transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '10px' }}>
                  Profile Photo
                </label>
              </div>

              {/* First Name */}
              <div className="mb-2">
                <label className={`block font-bold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>First Name</label>
                <input
                  type="text"
                  name="first_name"
                  value={profile.first_name}
                  onChange={handleChange}
                  className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
                      : 'border-gray-300 focus:ring-blue-500 text-gray-900'
                  }`}
                  required
                />
              </div>

              {/* Last Name */}
              <div className="mb-2">
                <label className={`block font-bold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  value={profile.last_name}
                  onChange={handleChange}
                  className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
                      : 'border-gray-300 focus:ring-blue-500 text-gray-900'
                  }`}
                />
              </div>

              {/* UG/PG */}
              <div className="mb-2">
                <label className={`block font-bold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>UG/PG</label>
                <select
                  name="ug_pg"
                  value={profile.ug_pg}
                  onChange={handleChange}
                  className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
                      : 'border-gray-300 focus:ring-blue-500 text-gray-900'
                  }`}
                >
                  <option value="">Select</option>
                  <option value="UG">Undergraduate</option>
                  <option value="PG">Postgraduate</option>
                </select>
              </div>

              {/* Academic Course */}
              <div className="mb-2">
                <label className={`block font-bold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>Academic Course</label>
                <input
                  type="text"
                  name="academic_course"
                  value={profile.academic_course}
                  onChange={handleChange}
                  className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
                      : 'border-gray-300 focus:ring-blue-500 text-gray-900'
                  }`}
                />
              </div>

              {/* Academic Year */}
              <div className="mb-2">
                <label className={`block font-bold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>Academic Year</label>
                <input
                  type="text"
                  name="academic_year"
                  value={profile.academic_year}
                  onChange={handleChange}
                  className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
                      : 'border-gray-300 focus:ring-blue-500 text-gray-900'
                  }`}
                />
              </div>

              {/* Email */}
              <div className="mb-2">
                <label className={`block font-bold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>Email</label>
                <input
                  type="email"
                  name="email"
                  value={profile.email}
                  onChange={handleChange}
                  className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
                      : 'border-gray-300 focus:ring-blue-500 text-gray-900'
                  }`}
                  readOnly
                />
              </div>

              {/* Mobile Number */}
              <div className="mb-2">
                <label className={`block font-bold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>Mobile Number</label>
                <input
                  type="text"
                  name="mobile_number"
                  value={profile.mobile_number}
                  onChange={handleChange}
                  className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
                      : 'border-gray-300 focus:ring-blue-500 text-gray-900'
                  }`}
                  readOnly
                />
              </div>

              {/* Alternate Mobile */}
<div className="mb-2">
  <label className={`block font-bold mb-1 transition-colors duration-300 ${
    isDarkMode ? 'text-gray-300' : 'text-gray-700'
  }`} style={{ fontSize: '11px' }}>Alternate Mobile Number</label>
  <input
    type="text"
    name="alternate_mobile_number"
    value={profile.alternate_mobile_number}
    onChange={handleChange}
    maxLength="10"
    onInput={(e) => {
      e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
    }}
    className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
      isDarkMode 
        ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
        : 'border-gray-300 focus:ring-blue-500 text-gray-900'
    }`}
  />
</div>

              {/* City */}
              <div className="mb-2">
                <label className={`block font-bold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>City</label>
                <input
                  type="text"
                  name="city"
                  value={profile.city}
                  onChange={handleChange}
                  className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
                      : 'border-gray-300 focus:ring-blue-500 text-gray-900'
                  }`}
                />
              </div>

<div className="mb-2">
  <label className={`block font-bold mb-1 transition-colors duration-300 ${
    isDarkMode ? 'text-gray-300' : 'text-gray-700'
  }`} style={{ fontSize: '11px' }}>
    Password
  </label>

  <div className="relative">
    <input
      type={showPassword ? "text" : "password"}
      name="password"
      value={profile.password || ''}
      onChange={handleChange}
      placeholder="Enter new password"
      className={`w-full px-3 py-1 pr-10 border rounded-md focus:outline-none focus:ring-1 text-sm transition-all duration-300 placeholder-gray-400 ${
        isDarkMode
          ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500'
          : 'bg-white border-gray-300 text-gray-900 focus:ring-blue-500'
      }`}
    />

    {/* PERFECTLY CENTERED EYE ICON */}
    <button
      type="button"
      onClick={togglePasswordVisibility}
      className={`absolute inset-y-0 right-0 flex items-center pr-3 transition-all duration-200 ${
        isDarkMode
          ? 'text-gray-400 hover:text-white'
          : 'text-gray-600 hover:text-gray-900'
      }`}
      title={showPassword ? "Hide password" : "Show password"}
    >
      {showPassword ? (
        <FaEyeSlash size={16} />
      ) : (
        <FaEye size={16} />
      )}
    </button>
  </div>


</div>

              {/* Address */}
              <div className="mb-2 md:col-span-3">
                <label className={`block font-bold mb-1 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>Address</label>
                <textarea
                  name="address"
                  value={profile.address}
                  onChange={handleChange}
                  rows="2"
                  className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
                      : 'border-gray-300 focus:ring-blue-500 text-gray-900'
                  }`}
                />
              </div>

{/* ====== OFFICIAL COLLEGE FIELDS - ONLY SHOW IF college_id > 0 ====== */}
{profile.college_id > 0 && (
  <>
    <div className="mb-2">
      <label className={`block font-bold mb-1 transition-colors duration-300 ${
        isDarkMode ? 'text-gray-300' : 'text-gray-700'
      }`} style={{ fontSize: '11px' }}>College Code</label>
      <input
        type="text"
        name="college_code"
        value={profile.college_code || ''}
        readOnly
        className="w-full px-2 py-1 border rounded-md bg-gray-100  text-gray-500 cursor-not-allowed text-[10px]"
      />
    </div>

    <div className="mb-2">
      <label className={`block font-bold mb-1 transition-colors duration-300 ${
        isDarkMode ? 'text-gray-300' : 'text-gray-700'
      }`} style={{ fontSize: '11px' }}>College Contact</label>
      <input
        type="text"
        name="contact_number"
        value={profile.contact_number || ''}
        readOnly
        className="w-full px-2 py-1 border rounded-md bg-gray-100  text-gray-500 cursor-not-allowed text-[10px]"
      />
    </div>

    <div className="mb-2">
      <label className={`block font-bold mb-1 transition-colors duration-300 ${
        isDarkMode ? 'text-gray-300' : 'text-gray-700'
      }`} style={{ fontSize: '11px' }}>Contact Person</label>
      <input
        type="text"
        name="contact_person"
        value={profile.contact_person || ''}
        readOnly
        className="w-full px-2 py-1 border rounded-md bg-gray-100  text-gray-500 cursor-not-allowed text-[10px]"
      />
    </div>
  </>
)}


{/* College Name Field in Edit Modal */}
<div className="mb-2">
  <label className={`block font-bold mb-1 transition-colors duration-300 ${
    isDarkMode ? 'text-gray-300' : 'text-gray-700'
  }`} style={{ fontSize: '11px' }}>College Name</label>
  <input
    type="text"
    name="college_name"
    value={profile.college_name || ''}
    onChange={handleChange}
    readOnly={profile.college_id > 0} // ← ADD THIS LINE
    className={`w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-1 text-[10px] transition-colors duration-300 ${
      profile.college_id > 0 
        ? 'bg-gray-100 text-gray-500 cursor-not-allowed' // ← ADD THIS STYLING
        : isDarkMode 
          ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-500' 
          : 'border-gray-300 focus:ring-blue-500 text-gray-900'
    }`}
  />

</div>




              {/* Active Toggle */}
              <div className="mb-2 md:col-span-3 flex items-center">
                <label htmlFor="is_active" className={`font-bold mr-3 transition-colors duration-300 ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-700'
                }`} style={{ fontSize: '11px' }}>Active Student</label>
                <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                  <input
                    type="checkbox"
                    name="is_active"
                    id="is_active"
                    checked={profile.is_active == "1"}
                    onChange={handleChange}
                    className="sr-only"
                  />
                  <label
                    htmlFor="is_active"
                    className={`block overflow-hidden h-5 rounded-full cursor-pointer transition-colors duration-200 ease-in-out ${
                      profile.is_active == "1" 
                        ? "bg-green-500" 
                        : isDarkMode 
                          ? "bg-gray-600" 
                          : "bg-gray-300"
                    }`}
                  >
                    <span
                      className={`absolute left-0 top-0 w-5 h-5 rounded-full shadow transform transition-transform duration-200 ease-in-out ${
                        isDarkMode ? 'bg-gray-300' : 'bg-white'
                      } ${profile.is_active == "1" ? "translate-x-full" : ""}`}
                    ></span>
                  </label>
                </div>
              </div>

              {/* Buttons */}
              <div className="md:col-span-3 flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-3 mt-3">
                <button
                  type="button"
                  onClick={() => setShowUpdateModal(false)}
                  className={`px-2 py-1 border rounded-md text-[10px] transition-colors duration-300 ${
                    isDarkMode 
                      ? 'border-gray-600 text-gray-300 hover:bg-gray-700' 
                      : 'border-gray-300 text-gray-700 hover:bg-gray-100'
                  }`}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`px-2 py-1 rounded-md text-[10px] transition-colors duration-300 ${
                    isSubmitting
                      ? 'bg-blue-400 text-white cursor-not-allowed'
                      : isDarkMode
                 ? 'bg-[#1C3664] hover:bg-blue-700 text-white'
              : 'bg-[#1C3664] text-white hover:bg-blue-800'
                  }`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Updating..." : "Update Student"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminStudentDashboard;